import { stringifyPostalCodeAddress } from './postal-address.helper';

const defaultPostalOpts = { defaultTxt: '-', addNewLine: false };

export interface WithPostalAddressDef {
  /**
   * Returns formatted postal address
   */
  fullPostalAddress: () => string;
  /**
   * Returns full `postal_address` object
   */
  getPostalAddress: () => { [key: string]: any };
}
/**
 * Add helpers for data with PostalAddress
 */
export const withPostalAddress = (): WithPostalAddressDef => {
  function fullPostalAddress({ defaultTxt, addNewLine } = defaultPostalOpts) {
    return stringifyPostalCodeAddress(this.postal_address, defaultTxt, addNewLine);
  }
  function getPostalAddress() {
    return { ...this.postal_address };
  }
  return { fullPostalAddress, getPostalAddress };
};
